import { useRef, useEffect, useCallback } from 'react';
import { useHover, UseHoverReturn } from './useHover';

export type UseVideoOnHoverReturn = UseHoverReturn & {
    videoRef: React.RefObject<HTMLVideoElement | null>;
};

export const useVideoOnHover = (): UseVideoOnHoverReturn => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const { isHovered, onMouseEnter: baseOnMouseEnter, onMouseLeave: baseOnMouseLeave } = useHover();

    const onMouseEnter = useCallback(() => {
        baseOnMouseEnter();
        if (videoRef.current) {
            videoRef.current.play().catch(() => {});
        }
    }, [baseOnMouseEnter]);

    const onMouseLeave = useCallback(() => {
        baseOnMouseLeave();
        if (videoRef.current) {
            videoRef.current.pause();
            try {
                videoRef.current.currentTime = 0;
            } catch {}
        }
    }, [baseOnMouseLeave]);

    // Cleanup effect для видео
    useEffect(() => {
        const video = videoRef.current;

        return () => {
            if (video) {
                video.pause();
                video.currentTime = 0;
                video.removeAttribute('src');
                video.load();
            }
        };
    }, []);

    return {
        isHovered,
        onMouseEnter,
        onMouseLeave,
        videoRef,
    };
};
